import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CalculatorPage from "@/pages/Calculator";
import Orders from "@/pages/Orders";
import Kanban from "@/pages/Kanban";
import Inventory from "@/pages/Inventory";
import Customers from "@/pages/Customers";
import Designs from "@/pages/Designs";
import UsersPage from "@/pages/Users";
import SettingsPage from "@/pages/Settings";
import { Loader2 } from "lucide-react";

const Protected = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="flex h-screen items-center justify-center bg-[#F8FAFC]"><Loader2 className="h-7 w-7 animate-spin text-blue-600" /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Layout><div className="rounded-xl border border-slate-200 bg-white p-10 text-center"><p className="font-heading text-lg font-bold text-slate-900">Akses Ditolak</p><p className="mt-1 text-sm text-slate-500">Peran Anda tidak memiliki izin untuk halaman ini.</p></div></Layout>;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/kalkulator" element={<Protected roles={["admin","kasir","designer"]}><CalculatorPage /></Protected>} />
            <Route path="/order" element={<Protected roles={["admin","kasir"]}><Orders /></Protected>} />
            <Route path="/produksi" element={<Protected><Kanban /></Protected>} />
            <Route path="/inventory" element={<Protected roles={["admin","designer","operator"]}><Inventory /></Protected>} />
            <Route path="/pelanggan" element={<Protected roles={["admin","kasir"]}><Customers /></Protected>} />
            <Route path="/desain" element={<Protected roles={["admin","designer"]}><Designs /></Protected>} />
            <Route path="/pengguna" element={<Protected roles={["admin"]}><UsersPage /></Protected>} />
            <Route path="/pengaturan" element={<Protected roles={["admin"]}><SettingsPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
